import { API_URL } from "./Config";
import { formatDate, formatDateTime } from "./DateUtils";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "./IComplianceInvestigation";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

/*
      {
        "incidentid": "79723798-92dc-e611-a4f6-0050568a69e2",
        "reference": "INCI011462",
        "subject": "Trigger Level Reached",
        "status": "Closed",
        "incidentcategory": "1. Minor",
        "approximatestart": "2017-01-14T08:00:00"
      },
*/

export interface IIncident {
  incidentid: string;
  reference: string;
  subject: string;
  status: string;
  incidentcategory: string;
  approximatestart: string;
}

export interface IIncidentDetails extends IDetailsResponse {
  incidentid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  licenceid: string;
  licenceprofileid: string;
  complianceinvestigationid: string;
  incidentcategory: string;
  nature: string;
  vulnerablereceptors: string;
  receptors: string;
  likelihoodofreoccurence: string;
  likelycause: string;
  newrecurring: string;
  datenotified: string;
  closeddate: string;
  approximatestart: string;
  firstnoticed: string;
  finishtime: string;
  notifiedparties: string;
  dischargepoint: string;
  emissionpointname: string;
  uncontrolledrelease: string;
  description: string;
  otherrelevantinformation: string;
  impactonenvironment: string;
  activityinprogress: string;
  dischargedetails: string;
  licence_regno: string;
  complianceInvestigationDetails?: IComplianceInvestigationDetails;
}

export const GetIncidentsFromComplianceInvestigationFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/Incident/incidentlistbyci?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incidents-ci`;
  }

  return url;
};

export async function GetIncidentDetailsAsync(
  incidentId: string
): Promise<IIncidentDetails> {
  var url = `${API_URL}/Incident/byid?incident_id=${incidentId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incident-details`;
  }

  var response = await fetch(url);
  var body = <IIncidentDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  if (body.complianceinvestigationid) {
    body.complianceInvestigationDetails =
      await GetComplianceInvestigationDetailsAsync(
        body.complianceinvestigationid
      );
  }

  return <IIncidentDetails>{
    response: response,
    incidentid: body.incidentid,
    type: body.type,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    complianceinvestigationid: body.complianceinvestigationid,
    incidentcategory: body.incidentcategory,
    nature: body.nature,
    vulnerablereceptors: body.vulnerablereceptors,
    receptors: body.receptors,
    likelihoodofreoccurence: body.likelihoodofreoccurence,
    likelycause: body.likelycause,
    newrecurring: body.newrecurring,
    datenotified: formatDate(body.datenotified),
    firstnoticed: formatDate(body.firstnoticed),
    closeddate: formatDate(body.closeddate),
    approximatestart: formatDateTime(body.approximatestart),
    finishtime: formatDateTime(body.finishtime),
    notifiedparties: body.notifiedparties,
    dischargepoint: body.dischargepoint,
    emissionpointname: body.emissionpointname,
    uncontrolledrelease: body.uncontrolledrelease,
    description: body.description,
    otherrelevantinformation: body.otherrelevantinformation,
    impactonenvironment: body.impactonenvironment,
    activityinprogress: body.activityinprogress,
    dischargedetails: body.dischargedetails,
    complianceInvestigationDetails: body.complianceInvestigationDetails,
    licence_regno: licenceDetails.reg_no,
  };
}
